var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-code"},[(_vm.unitData.content)?_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.unitData.content)}}):_c('p',{staticClass:"unit-empty"})])
}
var staticRenderFns = []

export { render, staticRenderFns }